import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const CANONICAL_BASE = 'https://www.pizzerialatorrecarmagnola.it';

interface PageSEOProps {
  title: string;
  description: string;
}

const PageSEO = ({ title, description }: PageSEOProps) => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = title;

    // Meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', description);

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    const canonicalUrl = `${CANONICAL_BASE}${pathname === '/' ? '/' : pathname}`;
    if (canonical) {
      canonical.href = canonicalUrl;
    } else {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      canonical.href = canonicalUrl;
      document.head.appendChild(canonical);
    }

    // OG url
    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', canonicalUrl);

    // OG title
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', title);

    // OG description
    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', description);
  }, [title, description, pathname]);

  return null;
};

export default PageSEO;
